import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Loading, Module, NavigationLinks, Section } from "../../components";
import { useRoteamentoDocumentos } from "../../hooks";
import { applyKey } from "../../utils";
import Content from "./CentralDocumentos.Style";
import { envs } from "../../config";
import { ReactComponent as ImageNavigationLink } from "../../assets/images/catalogo/ilustracao-mulher-trofeu.svg";

const RedirectPage = ({ para }) => {
  window.location.href = para;
  return null;
};

const DocumentPageLayout = (props) => {
  const { loading } = props;
  return (
    <Loading loading={loading}>
      <Content {...props} />
    </Loading>
  );
};

DocumentPageLayout.propTypes = {
  loading: PropTypes.bool.isRequired,
};

const DocumentNotFound = () => {
  return <Content>Documento não encontrado</Content>;
};
const CatalogoDocumentos = () => {
  return (
    <Section
      sectionName="nome da secao analytics"
      as={NavigationLinks}
      image={<ImageNavigationLink />}
      imgColumnSize={4}
      sectionTitle="Links Documentos Públicos"
    />
  );
};

const CentralDocumentos = () => {
  const { routes } = useRoteamentoDocumentos();
  const { origin } = window.location;

  const getFilesRoutes = useCallback(() => {
    return applyKey(routes, ([de, para]) => (
      <Module.Page
        path={de}
        page={RedirectPage}
        title={`${origin}/documentos${de}`}
        description={para}
        para={para}
        pageLayout={DocumentPageLayout}
        loading
      />
    ));
  }, [routes, origin]);

  return (
    <Module moduleName="Documentos">
      {getFilesRoutes()}

      {envs.enableCatalogoDocumentos ? (
        <Module.Page
          path="/catalogo"
          page={CatalogoDocumentos}
          loading={false}
          title="CatalogoDocumentos"
          disableNavigation
        />
      ) : null}
      <Module.Page
        path="/"
        page={DocumentNotFound}
        loading={false}
        title="Página Inicial"
        pageLayout={DocumentPageLayout}
      />
    </Module>
  );
};

export default CentralDocumentos;
